<script>
import moment from "@/utils/moment";
import dateMixin from "@/mixins/dateMixin";
import timeMixin from "@/mixins/timeMixin";
import numberMixin from "@/mixins/numberMixin";

import ProfessionalCard from "@/components/_Shared/Professionals/Card";
import Stars from "../../Professionals/Stars";

export default {
  mixins: [dateMixin, timeMixin, numberMixin],
  props: {
    cycle: {
      type: Object,
      required: true
    }
  },
  components: {
    ProfessionalCard,
    Stars
  },

  computed: {
    orderedEvents() {
      return this.cycle.orders
        .map(order => {
          return {
            ...order,
            starts_at: moment(order.schedule_event.starts_at)
          };
        })
        .sort((a, b) => a.starts_at.valueOf() - b.starts_at.valueOf());
    }
  },

  filters: {
    completedOrdersCount(num) {
      return num < 5 ? "< 5" : num;
    }
  }
};
</script>

<template>
  <div class="data with-border pt-15 pb-15">
    <div class="sub-title pt-15 pb-20">
      Detalhes
      <span class="italic">/ alguns detalhes da assinatura</span>
    </div>

    <div class="professional">
      <img :src="cycle.professional.account.profile.profile_picture" />
      <p>{{cycle.professional.account.first_name}} {{cycle.professional.account.last_name}}</p>
      <small>{{cycle.professional.completed_orders_count | completedOrdersCount}} limpezas</small>

      <stars :rating="cycle.professional.rating" />
    </div>

    <div class="text-center">
      <b>Valor total:</b>
      {{cycle.amount.total | intToCurrency}}
      <br />
      <b>Início e duração:</b>
      {{cycle.orders[0].schedule_event.starts_at | formatDate("[às] HH [hrs]")}} - {{cycle.orders[0].schedule_event.duration | secToHours(true)}}
      <br />
      <br />

      <b>Quando?</b>
      <div v-for="order in orderedEvents" :key="order.id" class="sub-title">
        {{order.schedule_event.starts_at | formatDate("DD/MM")}}
        <span
          class="italic"
        >/{{order.schedule_event.starts_at | formatDate("dddd")}}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sub-title {
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
}
.italic {
  font-weight: 300;
  font-style: italic;
  font-size: 16px;
  color: #999;
  text-transform: lowercase;
}
.bg-rating {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_contorno-01.png")
    no-repeat;
  width: 69px;
  height: 11px;
}
.stars {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_color-01.png")
    no-repeat;
  max-width: 69px;
  height: 11px;
}

.professional {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px;
  user-select: none;
}

.professional:first-child {
  margin-left: 0;
}

.professional:last-child {
  margin-right: 0;
}

.professional p {
  margin: 10px 0 5px 0;
  text-align: center;
}

.professional small {
  font-size: 12px;
}

.professional img:first-child {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 4px solid #f1f1f1f1;
  border-radius: 100%;
}

.professional img:last-child {
  height: 12px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/CycleData.vue